import { isFiniteNumber, parseStringRecord, StringRecord } from "./storageValidation";

const DRAW_COUNTS_KEY = "kanalearn.kanaDrawCounts.v1";
export type KanaDrawCounts = StringRecord<number>;

export function getDrawCounts(): KanaDrawCounts {
    try {
        const raw = localStorage.getItem(DRAW_COUNTS_KEY);
        return parseStringRecord(raw, isFiniteNumber);
    } catch {
        return {};
    }
}

export function setDrawCounts(counts: KanaDrawCounts): void {
    try {
        localStorage.setItem(DRAW_COUNTS_KEY, JSON.stringify(counts));
    } catch {
        // Best-effort: if storage is unavailable, counts just won't persist.
    }
}
